import type { DtoV1IncomeCalculatorAlert } from '~/__generated__/api';
import AlertStack from '~/common/components/Alerts/Alert/Alerts';
import {
  isEmploymentIncome,
  useIncomeInformation,
} from '~/pages/IncomeCalculator/hooks';

type CalculatorAlert = DtoV1IncomeCalculatorAlert;

type AlertsProps = {
  /** A list of alerts to display. */
  alerts: Array<CalculatorAlert>;
  selectedIncome?: ReturnType<typeof useIncomeInformation>['data'];
} & React.ComponentProps<typeof AlertStack>;

const Alerts = ({
  alerts,
  selectedIncome,
  ...props
}: Readonly<AlertsProps>) => {
  if (!alerts || alerts.length === 0) {
    return null;
  }

  const replacePlaceholders = (title: string) => {
    if (!selectedIncome) {
      return title;
    }

    return title.replace(
      '{EmployerName}',
      isEmploymentIncome(selectedIncome)
        ? selectedIncome.employerName
        : selectedIncome.propertyData.propertyName,
    );
  };

  return (
    <AlertStack
      {...props}
      alerts={alerts.map((x) => ({
        ...x,
        description: replacePlaceholders(x.description),
      }))}
    />
  );
};

export default Alerts;
